import styled from 'styled-components';

import { colors } from '../styles/variables';

const FilterContainerView = styled.div`
  position: relative;
  @media (min-width: 900px) {
    position: sticky;
    top: 137px;
  }
  & > .header {
    border: 1px solid ${colors.gray300};
    color: ${colors.gray800};
    font-weight: 600;
    padding: 8px 16px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    font-size: 14px;
  }
  & > .filters {
    border: 1px solid ${colors.gray300};
    border-top: none;
    padding: 16px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-bottom: 32px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    & > div {
      width: 48%;
      &:nth-of-type(2n+1) {
        margin-right: 4%;
      }
    }
    @media (min-width: 900px) {
      & > div {
        width: 100%;
        margin-right: 0!important;
      }
    }
  }
`;

export default FilterContainerView;
